import React from 'react'
import CustomTag from 'components/CustomTag'
import { Tooltip } from 'antd'

const JDStatus = ({ status, rejectedReason }) => {
  let colorType
  let tagMessage
  if (status == 0) {
    colorType = 'orange'
    tagMessage = 'Pending'
  } else if (status == 1) {
    colorType = 'green'
    tagMessage = 'Accepted'
  } else if (status == -1) {
    colorType = 'red'
    tagMessage = 'Rejected'
  }

  const formatCamelCase = str => {
    return str?.replace(/\w+/g, txt => {
      return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()
    })
  }

  if (status === -1) {
    return (
      <Tooltip
        title={
          rejectedReason
            ? `Reason for rejection: ${formatCamelCase(rejectedReason)}`
            : ''
        }
      >
        <p>
          <CustomTag colorType={colorType} message={tagMessage} />
        </p>
      </Tooltip>
    )
  }

  return <CustomTag colorType={colorType} message={tagMessage} />
}

export default JDStatus
